import { useState, useEffect } from 'react';
import { isPlatformNodeJS } from './platform.is-node.js';

function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
function useIsTouchDevice(options) {
  const [isMatch, setIsMatch] = useState(
    () => (options == null ? void 0 : options.immediate) && !isPlatformNodeJS() ? isTouchDevice() : void 0
  );
  useEffect(() => {
    setIsMatch(isTouchDevice());
  }, []);
  return isMatch;
}

export { isTouchDevice, useIsTouchDevice };
//# sourceMappingURL=platform.is-touch-device.js.map
